import ListDeleteModal from "../../components/modals/ListDeleteModal/ListDeleteModal";
import withListDeleteModalTracking from "./withListDeleteModalTracking";

const ListDeleteModalTracked = withListDeleteModalTracking(ListDeleteModal);

export default ListDeleteModalTracked;
